import React from "react";
import { Button, Flex } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { useFeatureFlag } from "@jsq/flags-react";
import { SPACING } from "~/styles/variables";
import { TransactionCategory } from "../../../../types";
import {
  getUnmappedCategoriesPluralList,
  getUnmappedCategoriesSingularList,
  getUnmappedCategoriesTitle,
} from "../helpers";
import StateTemplate from "./StateTemplate";

type Props = {
  unmappedCategories: TransactionCategory[];
  mappingName: string | null | undefined;
  entityName: string | undefined;
  dataMapsUrl: string;
  onBackToSettings: () => void;
};

const UnmappedCategoriesState = ({
  unmappedCategories,
  mappingName,
  entityName,
  dataMapsUrl,
  onBackToSettings,
}: Props) => {
  const showCapitalActivityLabelCanopy = useFeatureFlag(
    "showCapitalActivityLabelCanopy",
    false,
  );
  return (
    <StateTemplate
      title={getUnmappedCategoriesTitle(unmappedCategories, showCapitalActivityLabelCanopy)}
      subTitle={
        <>
          There are no{" "}
          {getUnmappedCategoriesSingularList(
            unmappedCategories,
            showCapitalActivityLabelCanopy,
          )}{" "}
          transaction types mapped in the mapping used by {entityName || "this entity"}. Please
          update the {mappingName ? <em>{mappingName}</em> : "current"} mapping to sync{" "}
          {getUnmappedCategoriesPluralList(unmappedCategories, showCapitalActivityLabelCanopy)}.
        </>
      }
      icon={<Icon type="exclamation-circle" color={Colors.Danger600} size="xx-large" />}
    >
      <Flex>
        <Button
          css={{ marginRight: SPACING.SMALL }}
          variant="neutral"
          onClick={onBackToSettings}
        >
          Back to settings
        </Button>
        <Button
          icon="external-link"
          iconPosition="right"
          onClick={() => window.open(dataMapsUrl, "_blank", "noopener,noreferrer")}
        >
          Update mapping
        </Button>
      </Flex>
    </StateTemplate>
  );
};

export default UnmappedCategoriesState;
